import { StateType } from '../index';
import { BaseGeniusStore } from './GeniusReducer';

export const geniusSelectedQuarterSelector = (state: StateType) => {
  const genius = state.get('genius') as BaseGeniusStore;
  return genius.selectedQuarter;
};
